import Globals from '../Globals'

const BASE_IP = `${Globals.BASE_URL}/`;

async function call(URL, data = {}, method, formData) {
    const token = await getData("token");
    var headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-requested-with': 'XMLHttpRequest',
    };
    if (formData) {
        delete headers['Content-Type'];
    }
    if (token) {
        headers['authorization'] = token;
    }
    var body = null;
    if(data|| formData){
        body = formData ? formData : JSON.stringify(data || {})
    }

    try {
        var response = await fetch(BASE_IP + URL, {
            method: method,
            headers: headers,
            body
        });
    } catch (err) {
        console.warn("eRR", err);
        return { success: false, message: "No se pudo conectar a la plataforma de Wheeling" };
    }

    if (response.status === 403) {
        return { success: false, status: 403 };
    }

    if (response.status === 200 && response._bodyText === "") {
        return {}
    }
    return response.json();
}

export function get(URL) {
    return call(URL, null, "GET");
}

export function post(URL, data, formData = false) {
    return call(URL, data, "POST", formData);
}

export function put(URL, data, formData = false) {
    return call(URL, data, "PUT", formData);
}

export function del(URL) {
    return call(URL, null, "DEL");
}

export function saveData(key, data) {
    return localStorage.setItem(key, data);
}

export function getData(key) {
    return localStorage.getItem(key);
}

export function removeData(key) {
    return localStorage.removeItem(key);
}